import { useState, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./App.css";

export default function App() {
  const [url, setUrl] = useState("");
  const [qrData, setQrData] = useState(null);
  const [logo, setLogo] = useState(null);
  const qrRef = useRef(null); // Referencia directa al QR

  const generateQR = () => {
    if (url.trim() !== "") {
      setQrData(url);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const downloadQR = () => {
    const fileName = prompt("Ingresa el nombre del archivo:", "qrcode");
    if (!fileName) return;

    const qrCanvas = qrRef.current?.querySelector("canvas"); // Accede al canvas correctamente
    if (!qrCanvas) {
      alert("Error: No se pudo obtener el código QR.");
      return;
    }

    const tempCanvas = document.createElement("canvas");
    const ctx = tempCanvas.getContext("2d");

    tempCanvas.width = qrCanvas.width;
    tempCanvas.height = qrCanvas.height;

    ctx.drawImage(qrCanvas, 0, 0);

    if (logo) {
      const img = new Image();
      img.src = logo;
      img.onload = () => {
        const logoSize = tempCanvas.width * 0.2;
        const x = (tempCanvas.width - logoSize) / 2;
        const y = (tempCanvas.height - logoSize) / 2;

        ctx.fillStyle = "white";
        ctx.beginPath();
        ctx.arc(x + logoSize / 2, y + logoSize / 2, logoSize / 2, 0, Math.PI * 2);
        ctx.fill();

        ctx.drawImage(img, x, y, logoSize, logoSize);

        const link = document.createElement("a");
        link.href = tempCanvas.toDataURL("image/png");
        link.download = `${fileName}.png`;
        link.click();
      };
    } else {
      const link = document.createElement("a");
      link.href = tempCanvas.toDataURL("image/png");
      link.download = `${fileName}.png`;
      link.click();
    }
  };

  return (
    <div className="container">
      <h1>Generador de Códigos QR</h1>

      <div className="input-container">
        <input
          type="text"
          placeholder="Ingresa la URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="input"
        />
        <button onClick={generateQR} className="add-btn">Generar QR</button>
      </div>

      <div className="upload-container">
        <input type="file" accept="image/*" onChange={handleImageUpload} />
      </div>

      {qrData && (
        <div className="qr-container" ref={qrRef}>
          <QRCodeCanvas
            value={qrData}
            size={250}
            includeMargin={true}
            imageSettings={logo ? { src: logo, width: 50, height: 50, excavate: true } : undefined}
          />
        </div>
      )}

      {qrData && <button onClick={downloadQR} className="download-btn">Descargar QR</button>}
    </div>
  );
}
